import styled from "styled-components";

export const TitleText = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #111827;
`;

export const SectionText = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
`;

export const EmphasizedText = styled.div`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
`;

export const BodyText = styled.div`
  margin: 0;
  font-size: 14px;
  color: #111827;
`;

export const MetaText = styled.div`
  margin: 0;
  font-size: 12px;
  color: #6b7280;
`;
